import { useMemo } from 'react';
import { FormProvider } from 'react-hook-form';
import { FilterDrawer, RhfSelect } from '@core/components';
import { useFilterDrawer } from '@core/hooks/useFilterDrawer';
import { getOptions } from '@core/utils/enum';
import type { ProductionItem } from '../../api/productionItems';
import { VestmentCategory } from '../enum/vestmentCategory';
import {
  EMPTY_PRODUCTION_FILTERS,
  type ProductionFilters,
  getProductionOrderOptions,
} from '../utils/production';

interface ProductionFilterDrawerProps {
  open: boolean;
  items: ProductionItem[];
  filters: ProductionFilters;
  onApply: (filters: ProductionFilters) => void;
  onClear: () => void;
  onClose: () => void;
}

const ProductionFilterDrawer: React.FC<ProductionFilterDrawerProps> = ({
  open,
  items,
  filters,
  onApply,
  onClear,
  onClose,
}) => {
  const { methods, handleApply, handleClear } = useFilterDrawer({
    open,
    filters,
    emptyFilters: EMPTY_PRODUCTION_FILTERS,
    onApply,
    onClear,
  });

  const orderOptions = useMemo(
    () => [
      { value: '', label: 'All orders' },
      ...getProductionOrderOptions(items),
    ],
    [items]
  );

  const categoryOptions = useMemo(
    () => [
      { value: '', label: 'All categories' },
      ...getOptions(VestmentCategory),
    ],
    []
  );

  return (
    <FormProvider {...methods}>
      <FilterDrawer
        open={open}
        title="Filter production"
        onApply={handleApply}
        onClear={handleClear}
        onClose={onClose}
      >
        <RhfSelect<ProductionFilters>
          name="orderId"
          label="Order"
          options={orderOptions}
        />
        <RhfSelect<ProductionFilters>
          name="category"
          label="Vestment category"
          options={categoryOptions}
        />
      </FilterDrawer>
    </FormProvider>
  );
};

export default ProductionFilterDrawer;
